import { useState } from "react";
import { faqList } from "@/mocks/content";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-20 md:py-24">
      <div className="container-site grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.5fr]">
        <div>
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold text-primary-700">
            常见问题
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            看番疑问,一网打尽
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            关于线路切换、自动选源、备用线路与多源播放的常见问题,这里都有答案。如果仍有疑问,欢迎通过页脚方式联系我们。
          </p>
          <a href="#anime" className="btn-outline mt-6">
            去挑选一部番剧
          </a>
        </div>

        <div className="flex flex-col gap-3">
          {faqList.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <article key={faq.question} className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-base font-bold text-foreground-950">{faq.question}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={`ri-add-line ${isOpen ? "rotate-45" : ""} transition-transform duration-300`} aria-hidden="true"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{faq.answer}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}